
import * as moment from 'moment';

export class DateFormatValueConverter {
    toView(date: Date) {
        var result = moment(date).format('DD.MM.YYYY');
        return result;
    }
}